// extracted by mini-css-extract-plugin
export default {"displayGridWrapper":"hzDJm","displayGrid":"oOPKf","gridColumn":"r2bpl"};